import { Taxes } from './Taxes';

export const taxes = new Taxes();
